//--------------------------------------------------Login Recovery--------------------------------------------------//
import { createAction } from '../../../modules/app/createAction';
import {
    INITIAL_RECOVERY,
    LOGIN_RECOVERY,
    LOGIN_RECOVERY_ANSWER, LOGIN_RECOVERY_ANSWER_FAILED, LOGIN_RECOVERY_ANSWER_SUCCESSFUL,
    LOGIN_RECOVERY_FAILED, LOGIN_RECOVERY_RESET, LOGIN_RECOVERY_SUCCESSFUL,
} from '../constants/recoveryConstants';
import {
    ILoginRecoveryAnswerRequest,
    ILoginRecoveryAnswerState,
    ILoginRecoveryState,
} from '../types/authTypes';
import {
    IInitialRecovery,
    ILoginRecovery, ILoginRecoveryAnswer, ILoginRecoveryAnswerFailed, ILoginRecoveryAnswerSuccessful,
    ILoginRecoveryFailed, ILoginRecoveryReset,
    ILoginRecoverySuccessful,
} from '../types/recoveryTypes';

/**
 * @description Open recovery page
 * @returns {ILoginHideError}
 */
export const initialRecovery = (): IInitialRecovery =>
    createAction(INITIAL_RECOVERY);
/**
 * @description Action to recovery login
 * @param {string} payload - user login info
 * @returns {ILoginRecovery}
 */
export const loginRecovery = (payload: string): ILoginRecovery =>
    createAction(LOGIN_RECOVERY, payload);
/**
 * @description Successful recovery login
 * @param {ILoginRecoveryState} payload - login recovery info
 * @returns {ILoginRecoverySuccessful}
 */
export const loginRecoverySuccessful = (payload: ILoginRecoveryState): ILoginRecoverySuccessful =>
    createAction(LOGIN_RECOVERY_SUCCESSFUL, payload);
/**
 * @description Failed recovery login
 * @param {string} message - error message
 * @returns {ILoginRecoveryFailed}
 */
export const loginRecoveryFailed = (payload: string): ILoginRecoveryFailed =>
    createAction(LOGIN_RECOVERY_FAILED, payload);

//--------------------------------------------Login Recovery Answer--------------------------------------------------//
/**
 * @description Action to answer recovery question
 * @param {ILoginRecoveryAnswerRequest} payload - user answer
 * @returns {ILoginRecoveryAnswer}
 */
export const loginRecoveryAnswer = (payload: ILoginRecoveryAnswerRequest): ILoginRecoveryAnswer =>
    createAction(LOGIN_RECOVERY_ANSWER, payload);
/**
 * @description Successful answer
 * @param {ILoginRecoveryState} payload - login recovery info
 * @returns {ILoginRecoverySuccessful}
 */
export const loginRecoveryAnswerSuccessful = (payload: ILoginRecoveryAnswerState): ILoginRecoveryAnswerSuccessful =>
    createAction(LOGIN_RECOVERY_ANSWER_SUCCESSFUL, payload);
/**
 * @description Failed answer
 * @param {string} message - error message
 * @returns {ILoginRecoveryFailed}
 */
export const loginRecoveryAnswerFailed = (payload: string): ILoginRecoveryAnswerFailed =>
    createAction(LOGIN_RECOVERY_ANSWER_FAILED, payload);
/**
 * @description Reset login recovery state
 * @returns {ILoginRecoveryFailed}
 */
export const loginRecoveryReset = (): ILoginRecoveryReset =>
    createAction(LOGIN_RECOVERY_RESET);

export type RecoveryTypes =
    IInitialRecovery |
    ILoginRecovery |
    ILoginRecoverySuccessful |
    ILoginRecoveryFailed |
    ILoginRecoveryAnswer |
    ILoginRecoveryAnswerSuccessful |
    ILoginRecoveryAnswerFailed |
    ILoginRecoveryReset;
